/** @jsx jsx */
import { jsx } from '@emotion/react';

import _ from 'lodash';

import { useTheme } from '@coursera/cds-core';

import { Button } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-users';

type Props = {
  onContinue: () => void;
  onCancel: () => void;
  disabled: boolean;
  onContinueLabel: string;
  onPrevious?: () => void;
};

const ModalFooter = ({ onContinue, onPrevious, disabled, onContinueLabel, onCancel }: Props) => {
  const theme = useTheme();
  return (
    <div css={{ display: 'flex', gap: theme.spacing(16), marginTop: theme.spacing(24) }}>
      <Button
        onClick={onContinue}
        disabled={disabled}
        variant="primary"
        data-e2e={`modal-${_.kebabCase(onContinueLabel)}`}
      >
        {onContinueLabel}
      </Button>
      <Button onClick={onCancel} variant="secondary" type="button">
        {_t('Cancel')}
      </Button>
      {onPrevious && (
        <Button variant="ghost" onClick={onPrevious} type="button">
          {_t('Back')}
        </Button>
      )}
    </div>
  );
};
export default ModalFooter;
